export default __webpack_public_path__ + "static/media/proj-greymatter.882845fd.jpg";